module.exports = __webpack_public_path__ + "img/WOLT_WM_TIPPSPIEL.1a08393b.png";